/* eslint-disable no-console */
import { isProdEnvironment } from './environmentUtilities';

export const log = (...args) => !isProdEnvironment && console.log(...args);
export const warn = (...args) => !isProdEnvironment && console.warn(...args);
export const error = (...args) => !isProdEnvironment && console.error(...args);

export default log;
